<div
  *ngIf="visible"
  @toastAnim
  class="toast"
  role="status"
  [class.toast--success]="toast?.type === 'success'"
  [class.toast--error]="toast?.type === 'error'"
  [class.toast--warning]="toast?.type === 'warning'"
  [class.toast--info]="toast?.type === 'info'"
  (click)="dismiss()"
>
  <mat-icon class="toast__icon">{{ icon }}</mat-icon>
  <span class="toast__message">{{ toast?.message }}</span>
</div>
